import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { Language } from '../translations/content';
import { MatrixRain } from './MatrixRain';
export function LanguageModal() {
  const {
    setLanguage,
    hasSelectedLanguage,
    setHasSelectedLanguage
  } = useLanguage();
  const handleLanguageSelect = (lang: Language) => {
    setLanguage(lang);
    setHasSelectedLanguage(true);
  };
  return <AnimatePresence data-id="element-71">
      {!hasSelectedLanguage && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center bg-matrix-bg" data-id="element-72">
          {/* Matrix Rain Background */}
          <div className="absolute inset-0" data-id="element-73">
            <MatrixRain data-id="element-74" />
          </div>

          {/* Dark overlay */}
          <div className="absolute inset-0 bg-black/60" data-id="element-75" />

          {/* Content */}
          <motion.div initial={{
        scale: 0.95,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="relative z-10 w-full max-w-md mx-4" data-id="element-76">
            {/* Decorative border frame */}
            <div className="relative border-2 border-matrix-accent/50 rounded-lg p-8 md:p-12" data-id="element-77">
              {/* Corner accents */}
              <div className="absolute top-0 left-0 w-16 h-16 border-l-2 border-t-2 border-matrix-accent" data-id="element-78" />
              <div className="absolute top-0 right-0 w-16 h-16 border-r-2 border-t-2 border-matrix-accent" data-id="element-79" />
              <div className="absolute bottom-0 left-0 w-16 h-16 border-l-2 border-b-2 border-matrix-accent" data-id="element-80" />
              <div className="absolute bottom-0 right-0 w-16 h-16 border-r-2 border-b-2 border-matrix-accent" data-id="element-81" />

              {/* Title */}
              <motion.div initial={{
            y: -20,
            opacity: 0
          }} animate={{
            y: 0,
            opacity: 1
          }} transition={{
            delay: 0.4
          }} className="text-center mb-8" data-id="element-82">
                <h1 className="text-3xl md:text-4xl font-black text-white uppercase mb-2 tracking-tight" data-id="element-83">
                  ROMPE LA MATRIX
                </h1>
                <motion.h2 className="text-4xl md:text-5xl font-black uppercase tracking-tight" style={{
              background: 'linear-gradient(to bottom, #00d9ff, #00ffcc)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }} animate={{
              textShadow: ['0 0 20px rgba(0, 217, 255, 0.5)', '0 0 40px rgba(0, 217, 255, 0.8)', '0 0 20px rgba(0, 217, 255, 0.5)']
            }} transition={{
              duration: 2,
              repeat: Infinity
            }} data-id="element-84">
                  3-6-9
                </motion.h2>
                {/* Underline */}
                <motion.div className="h-1 bg-gradient-to-r from-transparent via-matrix-accent to-transparent mx-auto mt-4" initial={{
              width: 0
            }} animate={{
              width: '60%'
            }} transition={{
              delay: 0.6,
              duration: 0.8
            }} data-id="element-85" />
              </motion.div>

              {/* Subtitle */}
              <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.7
          }} className="text-center text-white text-sm md:text-base mb-8" data-id="element-86">
                Select your language / Selecciona tu idioma
              </motion.p>

              {/* Language Buttons */}
              <div className="space-y-4 mb-8" data-id="element-87">
                <motion.button initial={{
              opacity: 0,
              x: -30
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.8
            }} onClick={() => handleLanguageSelect('en')} className="w-full bg-transparent border-2 border-matrix-accent rounded-lg p-4 text-white text-lg font-bold uppercase tracking-wide transition-all duration-300 hover:bg-matrix-accent/10 hover:shadow-lg hover:shadow-matrix-accent/30" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} data-id="element-88">
                  ENGLISH
                </motion.button>

                <motion.button initial={{
              opacity: 0,
              x: -30
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.9
            }} onClick={() => handleLanguageSelect('es')} className="w-full bg-transparent border-2 border-matrix-accent rounded-lg p-4 text-white text-lg font-bold uppercase tracking-wide transition-all duration-300 hover:bg-matrix-accent/10 hover:shadow-lg hover:shadow-matrix-accent/30" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} data-id="element-89">
                  ESPAÑOL
                </motion.button>
              </div>

              {/* Bottom text */}
              <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 1
          }} className="text-center text-matrix-accent text-xs md:text-sm uppercase tracking-wider" data-id="element-90">
                Prepárate para salir de la Matrix. / Get ready to exit the
                Matrix
              </motion.p>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}